import { ReactNode } from 'react';

interface SidebarItemProps {
    icon?: ReactNode;
    label: string;
    isActive: boolean;
    onClick: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ icon, label, isActive, onClick }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={`flex min-h-11 w-full items-center gap-3 rounded-lg px-4 py-3 text-left transition-colors ${isActive
                    ? 'bg-white text-indigo-600 shadow-md'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
        >
            {icon && <span className="text-lg">{icon}</span>}
            <span className="font-medium">{label}</span>
        </button>
    );
};

export default SidebarItem;